module.exports = __webpack_public_path__ + "static/media/Make It Rock.85af4689.jpg";